import { render, staticRenderFns } from "./notificationsNav.vue?vue&type=template&id=688176bc&scoped=true"
import script from "./notificationsNav.vue?vue&type=script&lang=js"
export * from "./notificationsNav.vue?vue&type=script&lang=js"
import style0 from "./notificationsNav.vue?vue&type=style&index=0&id=688176bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688176bc",
  null
  
)

export default component.exports